import React, { useState } from "react";
import { isEmpty } from "lodash";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { GetInitials, EditActionSlider } from "../../../components";
import {
  getCommaSeparatedValuesFromArr,
  getNullTableItem,
} from "../../../utils";
import AddToolTip from "../../../components/AddToolTip";
import { useDeepEffect } from "../../../abstracts";
import { getCompanyLogo } from "../../../services";

const ClearingPartnerCard = ({ name, noOfPlan, logo, id }) => {
  const clearingPartnerLogo = logo;

  return (
    <div className="clearing-partner-card-item">
      <div className="clearing-partner-card-item-content">
        {/* <EditActionSlider editLink={editLink} menu="company" /> */}

        <div className="clearing-partner-icon-wrapper d-flex justify-content-center">
          {!isEmpty(clearingPartnerLogo) ? (
            <img
              alt=""
              src={clearingPartnerLogo}
              style={{ width: "90px", height: "74px" }}
              className="img-fluid"
            />
          ) : (
            <GetInitials name={name} />
          )}
        </div>
        {/* <div className="d-flex flex-column plan-details-wrapper px-2">
            
            </div> */}
        <div className="clearing-partner-description-box">
          <AddToolTip
            name={name}
            className="ft-14 font-weight-500 pb-3 clearing-partner-name"
          />
          <div className="clearing-partner-associated-plans">
            {noOfPlan} Associated Plans
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClearingPartnerCard;
